import { render, staticRenderFns } from "./SubdivisionsView.vue?vue&type=template&id=cda0f41a&"
import script from "./SubdivisionsView.vue?vue&type=script&lang=js&"
export * from "./SubdivisionsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports